// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3NJsZ","noInteraction":"EventWrapper_noInteraction__tiEBT","pointerPassthrough":"EventWrapper_pointerPassthrough__3stOe"};